let uiWidth = 0;
let uiHeight = 0;
let screenWidth = 1;
let screenHeight = 1;

export function setUIWidth(size: number) {
    uiWidth = size;
}
export function setUIHeight(size: number) {
    uiHeight = size;
}
export function getUIWidth() {
    return uiWidth;
}
export function getUIHeight() {
    return uiHeight;
}

export function getUIDimensions() {
    return [uiWidth, uiHeight];
}
export function setScreenSize(w: number, h: number) {
    screenWidth = w;
    screenHeight = h;
}
export function getScreenSize() {
    return {
        width: screenWidth,
        height: screenHeight,
    };
}

export enum CanvasOrientation {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL',
}

export function getOrientation() {
    const { width, height } = getScreenSize();
    return width > height ? CanvasOrientation.HORIZONTAL : CanvasOrientation.VERTICAL;
}

export function isHorizontal() {
    return getOrientation() === CanvasOrientation.HORIZONTAL;
}
export function isVertical() {
    return getOrientation() === CanvasOrientation.VERTICAL;
}
export function getSizeByScreenWidth(value: number) {
    const valuePrc = value / 100;
    const edge = uiWidth;
    return valuePrc * edge;
}
export function getSizeByScreenHeight(value: number) {
    const valuePrc = value / 100;
    const edge = uiHeight;
    return valuePrc * edge;
}
